const questions = [
  {},
  {
    prev: "",
    question: "당신의 투데이 컬러는?",
    answers: ["그린", "핑크", "화이트", "브라운", "베이지"]
  },
  {
    question: "당신은 언제 향수를 사용하실 건지요?",
    answers: [
      "평범한 하루 일상에서",
      "특별한 모임과 파티를 위해",
      "평온한 하루를 보내기 위해"
    ]
  },
  {
    question: "당신의 오늘의 OOTD는 무엇인가요?",
    answers: [
      "심플한 미니멀룩",
      "오늘은 꾸꾸꾸!",
      "비즈니스 포멀룩",
      "사랑스러운 로맨틱"
    ]
  },
  {
    question: "오늘 당신이 표현하고 싶은 무드는 무엇인가요?",
    answers: [
      {
        q: "깨끗하고 프레쉬한",
        a: {
          options: [
            {
              select: "깔끔한",
              result: "p8",
              img: "/images/p8.png",
              tag: "#깨끗한 #비누살결향 #린넨향",
              text: [
                "사각거리는 화이트 셔츠와",
                "살결 사이의 부드러운 온기를 느껴보세요.",
                "정갈하게 갓 세탁한 린넨의 깨끗함과",
                "피부결 그대로의 부드러움을 담은 향기"
              ],
              path: 'https://loe-cosmetics.com/product/%EB%A1%9C%EC%97%90-%ED%99%94%EC%9D%B4%ED%8A%B8%EC%85%94%EC%B8%A0-edt-50ml/30/category/46/display/1/'
            },
            {
              select: "순수한",
              result: "p3",
              img: "/images/p3.png",
              tag: "#보송보송 #청결한 #빨래향",
              text: [
                "푸른 하늘과 깨끗한 바람, 따스한 햇살에",
                "보송보송하게 마른 세탁물에서 느껴지는",
                "기분 좋은 청결함과 부드러움"
              ],
              path: 'https://loe-cosmetics.com/product/%EB%A1%9C%EC%97%90-%EB%9F%B0%EB%93%9C%EB%A6%AC-%EC%84%BC%ED%8A%B8-edt-50ml/50/category/46/display/1/'
            },
            {
              select: "세련된",
              result: "p8",
              img: "/images/p8.png",
              tag: "#깨끗한 #비누살결향 #린넨향",
              text: [
                "사각거리는 화이트 셔츠와 살결 사이의",
                "부드러운 온기를 느껴보세요.",
                "정갈하게 갓 세탁한 린넨의 깨끗함과",
                "피부결 그대로의 부드러움을 담은 향기"
              ],
              path: 'https://loe-cosmetics.com/product/%EB%A1%9C%EC%97%90-%ED%99%94%EC%9D%B4%ED%8A%B8%EC%85%94%EC%B8%A0-edt-50ml/30/category/46/display/1/'
            },
            {
              select: "청초한",
              result: "p5",
              img: "/images/p5.png",
              tag: "#맑은 #라일락 #생화향",
              text: [
                "하늘 가득 따스한 햇살이 설레이는 날",
                "살랑이는 부드러운 바람결에 실려 오는",
                "맑은 라일락 향기"
              ],
              path: 'https://loe-cosmetics.com/product/%EB%A1%9C%EC%97%90-%EB%9D%BC%EC%9D%BC%EB%9D%BD-%EC%8A%A4%EC%B9%B4%EC%9D%B4-edt-50ml/40/category/46/display/1/'
            }
          ],
          question: "오늘 당신이 끌리는 향기의 단어는 무엇인가요?"
        }
      },
      {
        q: "부드럽고 무드있는",
        a: {
          options: [
            {
              select: "상쾌한",
              result: "p3",
              img: "/images/p3.png",
              tag: "#보송보송 #청결한 #빨래향",
              text: [
                "푸른 하늘과 깨끗한 바람, 따스한 햇살에",
                "보송보송하게 마른 세탁물에서 느껴지는",
                "기분 좋은 청결함과 부드러움"
              ],
              path: 'https://loe-cosmetics.com/product/%EB%A1%9C%EC%97%90-%EB%9F%B0%EB%93%9C%EB%A6%AC-%EC%84%BC%ED%8A%B8-edt-50ml/50/category/46/display/1/'
            },
            {
              select: "달콤한",
              result: "p7",
              img: "/images/p7.png",
              tag: "#새콤달콤 #복숭아 #홍차향",
              text: [
                "화사한 꽃들이 피어난 정원에서",
                "즐기는 애프터눈 티 타임",
                "새콤하게 익은 복숭아,",
                "달콤한 디저트, 쌉싸름한 홍차의 조화"
              ],
              path: 'https://loe-cosmetics.com/product/%EB%A1%9C%EC%97%90-%ED%94%BC%EC%B9%98%EC%95%A4%ED%8B%B0-edt-50ml/55/category/46/display/1/'
            },
            {
              select: "분위기 있는",
              result: "p6",
              img: "/images/p6.png",
              tag: "#포근한 #바닐라살결향 #따뜻한향기",
              text: [
                "나른함이 느껴지는 온전한 휴식의 시간",
                "매끄러운 피부를 감싸는 포근한 블랭킷",
                "따뜻한 라떼, ",
                "그리고 부드러운 바닐라 향기가 만들어 내는",
                "완벽한 여유로움을 느껴보세요"
              ],
              path: 'https://loe-cosmetics.com/product/%EB%A1%9C%EC%97%90-%EB%A0%88%EC%9D%B4%EC%A7%80-%EB%B0%94%EB%8B%90%EB%9D%BC-edt-50ml/29/category/46/display/1/'
            }
          ],
          question: "오늘 당신이 끌리는 향기의 단어는 무엇인가요?"
        }
      },
      {
        q: "자연스럽고 편안한",
        a: {
          options: [
            {
              select: "단정한",
              result: "p1",
              img: "/images/p1.png",
              tag: "#나무향 #숲속향 #우디의 정석",
              text: [
                "생명력이 가득한 깊은 숲의 풍경",
                "안개, 이끼, 서로를 감싸 안고 있는",
                "울창하고 커다란 나무",
                "나무 그대로의 편안함을 가득 담은 향기"
              ],
              path: 'https://loe-cosmetics.com/product/%EB%A1%9C%EC%97%90-%EC%8B%A0%EC%8B%9C%EC%96%B4-%EC%9A%B0%EB%93%9C-edp-50ml/31/category/46/display/1/'
            },
            {
              select: "포근한",
              result: "p6",
              img: "/images/p6.png",
              tag: "#포근한 #바닐라살결향 #따뜻한향기",
              text: [
                "나른함이 느껴지는 온전한 휴식의 시간",
                "매끄러운 피부를 감싸는 포근한 블랭킷",
                "따뜻한 라떼, ",
                "그리고 부드러운 바닐라 향기가 만들어 내는",
                "완벽한 여유로움을 느껴보세요"
              ],
              path: 'https://loe-cosmetics.com/product/%EB%A1%9C%EC%97%90-%EB%A0%88%EC%9D%B4%EC%A7%80-%EB%B0%94%EB%8B%90%EB%9D%BC-edt-50ml/29/category/46/display/1/'
            },
            {
              select: "편안한",
              result: "p3",
              img: "/images/p3.png",
              tag: "#보송보송 #청결한 #빨래향",
              text: [
                "푸른 하늘과 깨끗한 바람, 따스한 햇살에",
                "보송보송하게 마른 세탁물에서 느껴지는",
                "기분 좋은 청결함과 부드러움"
              ],
              path: 'https://loe-cosmetics.com/product/%EB%A1%9C%EC%97%90-%EB%9F%B0%EB%93%9C%EB%A6%AC-%EC%84%BC%ED%8A%B8-edt-50ml/50/category/46/display/1/'
            },
            {
              select: "깔끔한",
              result: "p8",
              img: "/images/p8.png",
              tag: "#깨끗한 #비누살결향 #린넨향",
              text: [
                "사각거리는 화이트 셔츠와 살결 사이의",
                "부드러운 온기를 느껴보세요.",
                "정갈하게 갓 세탁한 린넨의 깨끗함과",
                "피부결 그대로의 부드러움을 담은 향기"
              ],
              path: 'https://loe-cosmetics.com/product/%EB%A1%9C%EC%97%90-%ED%99%94%EC%9D%B4%ED%8A%B8%EC%85%94%EC%B8%A0-edt-50ml/30/category/46/display/1/'
            }
          ],
          question: "오늘 당신이 끌리는 향기의 단어는 무엇인가요?"
        }
      },
      {
        q: "에너지가 넘치는",
        a: {
          options: [
            {
              select: "프레쉬한",
              result: "p2",
              img: "/images/p2.png",
              tag: "#꽃집향 #꽃시장향 #생화향",
              text: [
                "비가 개인 후, 꽃이 가득 피어 있는 들판을 산책할 때,",
                "날씨가 좋은 어느 날 새벽 꽃시장 입구를 들어섰을 때,",
                "온갖 꽃들이 가득한 예쁜 꽃집을 지나갈 때,",
                "느낄 수 있는 생생한 향기"
              ],
              path: 'https://loe-cosmetics.com/product/%EB%A1%9C%EC%97%90-%ED%95%98%EC%89%AC%EA%B7%B8%EB%A6%B0-edt-50ml/23/category/46/display/1/'
            },
            {
              select: "사랑스러운",
              result: "p7",
              img: "/images/p7.png",
              tag: "#새콤달콤 #복숭아 #홍차향",
              text: [
                "화사한 꽃들이 피어난 정원에서",
                "즐기는 애프터눈 티 타임",
                "새콤하게 익은 복숭아,",
                "달콤한 디저트, 쌉싸름한 홍차의 조화"
              ],
              path: 'https://loe-cosmetics.com/product/%EB%A1%9C%EC%97%90-%ED%94%BC%EC%B9%98%EC%95%A4%ED%8B%B0-edt-50ml/55/category/46/display/1/'
            },
            {
              select: "개성있는",
              result: "p4",
              img: "/images/p4.png",
              tag: "#새벽의 #숲속향기",
              text: [
                "새벽 공기처럼 청량한 시트러스와 ",
                "차분한 모스, 그리고 우디가 어우러진",
                "맑고 고급스러운 향기"
              ],
              path: 'https://loe-cosmetics.com/product/%EB%A1%9C%EC%97%90-%EB%AA%A8%EC%8A%A4%EA%B7%B8%EB%A6%B0-edt-50ml/48/category/46/display/1/'
            }
          ],
          question: "오늘 당신이 끌리는 향기의 단어는 무엇인가요?"
        }
      },
      {
        q: "매혹적이고 관능적인",
        a: {
          options: [
            {
              select: "화려한",
              result: "p6",
              img: "/images/p6.png",
              tag: "#포근한 #바닐라살결향 #따뜻한향기",
              text: [
                "나른함이 느껴지는 온전한 휴식의 시간",
                "매끄러운 피부를 감싸는 포근한 블랭킷",
                "따뜻한 라떼, ",
                "그리고 부드러운 바닐라 향기가 만들어 내는",
                "완벽한 여유로움을 느껴보세요"
              ],
              path: 'https://loe-cosmetics.com/product/%EB%A1%9C%EC%97%90-%EB%A0%88%EC%9D%B4%EC%A7%80-%EB%B0%94%EB%8B%90%EB%9D%BC-edt-50ml/29/category/46/display/1/'
            },
            {
              select: "달콤한",
              result: "p7",
              img: "/images/p7.png",
              tag: "#새콤달콤 #복숭아 #홍차향",
              text: [
                "화사한 꽃들이 피어난 정원에서",
                "즐기는 애프터눈 티 타임",
                "새콤하게 익은 복숭아,",
                "달콤한 디저트, 쌉싸름한 홍차의 조화"
              ],
              path: 'https://loe-cosmetics.com/product/%EB%A1%9C%EC%97%90-%ED%94%BC%EC%B9%98%EC%95%A4%ED%8B%B0-edt-50ml/55/category/46/display/1/'
            },
            {
              select: "개성있는",
              result: "p4",
              img: "/images/p4.png",
              tag: "#새벽의 #숲속향기",
              text: [
                "새벽 공기처럼 청량한 시트러스와 ",
                "차분한 모스, 그리고 우디가 어우러진",
                "맑고 고급스러운 향기"
              ],
              path: 'https://loe-cosmetics.com/product/%EB%A1%9C%EC%97%90-%EB%AA%A8%EC%8A%A4%EA%B7%B8%EB%A6%B0-edt-50ml/48/category/46/display/1/'
            }
          ],
          question: "오늘 당신이 끌리는 향기의 단어는 무엇인가요?"
        }
      }
    ]
  }
];

export default questions;
